import { PREREQUISITES, DEBRIDEMENT_TYPES } from "./debridementConfig";

export const POLICY_LABEL = { R: "R", Rx: "R*", O: "O" };

export const POLICY_WIRE = {
  R: "Required",
  Rx: "RequiredWithOverride",
  O: "Optional",
};

export const policyFor = (prereq, careSetting) => prereq?.policy?.[careSetting] ?? null;

export const visiblePrerequisites = (careSetting) => PREREQUISITES.filter((p) => policyFor(p, careSetting) !== null);

export const complianceFlags = (careSetting, answers) => {
  const flags = [];
  visiblePrerequisites(careSetting).forEach((p) => {
    const policy = policyFor(p, careSetting);
    const answer = answers?.[p.key];

    if (answer?.value === "no") {
      flags.push({
        prerequisiteKey: p.key,
        label: p.label,
        reasonCode: answer.reasonCode || null,
        reasonText: answer.reasonText || null,
        severity: policy === "R" ? "High" : "Medium",
      });
    } else if (!answer?.value && policy === "R") {
      flags.push({
        prerequisiteKey: p.key,
        label: p.label,
        reasonCode: null,
        reasonText: "Not answered",
        severity: "Medium",
      });
    }
  });
  return flags;
};

export const readinessCount = (careSetting, answers) => {
  const visible = visiblePrerequisites(careSetting);
  const answered = visible.filter((p) => {
    const a = answers?.[p.key];
    return a?.value === "yes" || a?.value === "na";
  }).length;
  return { answered, total: visible.length };
};

export const missingReasons = (careSetting, answers) =>
  visiblePrerequisites(careSetting)
    .filter((p) => answers?.[p.key]?.value === "no" && !answers[p.key]?.reasonCode)
    .map((p) => p.key);

export const typeByKey = (key) => DEBRIDEMENT_TYPES.find((t) => t.key === key) || null;

export const approachesFor = (typeKey) => typeByKey(typeKey)?.approaches ?? [];

export const requiresApproach = (typeKey) => approachesFor(typeKey).length > 0;

export const showsSubcutaneousSubList = (depthKey) => depthKey === "subcutaneoustissue";

/* ── initial state ───────────────────────────────────────────────────── */

export const stateFromResponse = (resp) => ({
  isDebridementPerformed: resp?.isDebridementPerformed ?? "yes",
  notPerformedReason: resp?.notPerformedReason ?? "",
  prerequisiteAnswers: hydratePrerequisites(resp?.prerequisites),
  surgicalDebridementProcedure: resp?.surgicalDebridementProcedure ?? "",
  nonExcisionalApproach: resp?.nonExcisionalApproach ?? "",
  depthOfDebridement: resp?.depthOfDebridement ?? "",
  necroticSubcutaneousTissue: resp?.necroticSubcutaneousTissue ?? [],
  necroticTissue: resp?.necroticTissue ?? [],
  instrumentsUsed: resp?.instrumentsUsed ?? [],
  surfaceAreaOfNecroticSkinTissue: resp?.surfaceAreaOfNecroticSkinTissue ?? "",
  surfaceAreaOfNecroticSubqTissue: resp?.surfaceAreaOfNecroticSubqTissue ?? "",
  techniqueUsed: resp?.techniqueUsed ?? "",
  painAfter: resp?.painAfter ?? "",
  postDebridementBleedingAmount: resp?.postDebridementBleedingAmount ?? "",
  stoppedBleedingContactPressure: resp?.stoppedBleedingContactPressure ?? "",
});

const hydratePrerequisites = (list) => {
  const out = {};
  (Array.isArray(list) ? list : []).forEach((p) => {
    out[p.key] = {
      value: p.answer ?? null,
      selection: p.value ?? null,
      reasonCode: p.reasonCode ?? null,
      reasonText: p.reasonText ?? null,
    };
  });
  return out;
};
